export default __webpack_public_path__ + "img/shape-square-small.05c000f8.svg";